import { Box } from '@mui/material'
import { alpha } from '@mui/material/styles'
import SessionCard from './SessionCard'

export default function DayColumn({ entries, pxPerHour, height, isToday, canView, compactText, isLast, column, row }) {
  return (
    <Box
      sx={{
        gridColumn: column,
        gridRow: row,
        position: 'relative',
        height,
        zIndex: 2,
        borderRight: isLast ? 'none' : '1px solid',
        borderColor: 'divider',
        bgcolor: isToday
          ? theme => alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.1 : 0.05)
          : 'transparent',
      }}
    >
      {entries.map(entry => (
        <SessionCard
          key={`${entry.session.periodId}-${entry.start}-${entry.lane}`}
          entry={entry}
          pxPerHour={pxPerHour}
          canView={canView}
          compactText={compactText}
        />
      ))}
    </Box>
  )
}
